<template>
  <AutoPassForm />
</template>
<script>
import AutoPassForm from "../components/Forms/AutoPassForm"
export default {
  name: "AutoPass",
  components: { AutoPassForm }
}
</script>
